import React from 'react';
import { Card } from '../ui/Card';
import { LatexRenderer } from '../ui/LatexRenderer';
import { Question, VisualAid } from '../../types';
import { VisualAidFactory, shouldShowVisualAid } from '../visuals/VisualAidFactory';
interface QuestionCardCleanProps {
  question: Question;
  children: React.ReactNode;
  visualAid?: VisualAid; // Optional visual aid to render alongside question
}
export function QuestionCardClean({
  question,
  children,
  visualAid
}: QuestionCardCleanProps) {
  // Check if we should show the visual aid in the question phase (always visible)
  // We pass isCorrect=undefined because in question phase we don't know yet,
  // but 'always' type visuals should show regardless.
  const showVisual = visualAid && visualAid.showWhen === 'always';
  return <Card className="p-6 md:p-10 shadow-xl shadow-slate-200/50 border-slate-100 bg-white" data-id="element-1409">
      {/* Context/Story */}
      {question.context && <div className="mb-6 text-lg text-slate-600 italic border-l-4 border-indigo-200 pl-4 py-2 bg-indigo-50/30 rounded-r-lg" data-id="element-1410">
          <LatexRenderer content={question.context} data-id="element-1411" />
        </div>}

      <div className="flex flex-col gap-8" data-id="element-1412">
        {/* Main Question */}
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 leading-snug" data-id="element-1413">
          <LatexRenderer content={question.question} data-id="element-1414" />
        </h2>

        {/* Visual Aid (if 'always' visible) */}
        {showVisual && <div className="w-full my-2 flex justify-center" data-id="element-1415">
            <div className="w-full max-w-xl" data-id="element-1416">
              <VisualAidFactory visualAid={visualAid} data-id="element-1417" />
            </div>
          </div>}

        {/* Interactive Area (Rendered by Factory) */}
        <div className="w-full mt-2" data-id="element-1418">{children}</div>
      </div>
    </Card>;
}